/**
 * BuyMeCoffeeButton - Donation button for Buy Me a Coffee
 */

import React from 'react';
import { motion } from 'framer-motion';

interface BuyMeCoffeeButtonProps {
  username: string;
  show: boolean;
}

const BuyMeCoffeeButton: React.FC<BuyMeCoffeeButtonProps> = ({ username, show }) => {
  if (!show || !username) return null;

  const handleClick = () => {
    window.open(`https://www.buymeacoffee.com/${username}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.3 }}
      className="fixed bottom-8 right-8 z-[5]"
    >
      <button
        onClick={handleClick}
        className="group relative px-6 py-3 bg-black
                   text-white font-semibold rounded-full shadow-lg border-2 border-white
                   hover:shadow-xl hover:scale-105 hover:bg-white hover:text-black transition-all duration-300
                   flex items-center gap-2"
        aria-label="Support on Buy Me a Coffee"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-5 h-5"
        >
          <path d="M2 21h19v-3H2v3zM20 8H4V6h16v2zm0-4H4c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
        </svg>
        <span>Buy Me a Coffee</span>
      </button>
    </motion.div>
  );
};

export default BuyMeCoffeeButton;
